/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmSearchHandlerInfo } from '../models/EvmSearchHandlerInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmSearchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmSearchHandlerInfo OK
     * @throws ApiError
     */
    public getEvmSearchHandler({
        term,
        filterBy = 'ALL',
    }: {
        term: string,
        filterBy?: 'ALL' | 'BLOCK' | 'TRANSACTION' | 'ADDRESS' | 'TOKEN' | 'MODULE' | 'COIN' | 'FUNGIBLE_ASSET' | 'COLLECTION' | 'OBJECT' | 'BATCH_TRX',
    }): CancelablePromise<Array<EvmSearchHandlerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/search/handler',
            query: {
                'filterBy': filterBy,
                'term': term,
            },
        });
    }

    /**
     * @returns EvmSearchHandlerInfo OK
     * @throws ApiError
     */
    public getEvmSearchHandler1({
        term,
        filterBy = 'ALL',
    }: {
        term: string,
        filterBy?: 'ALL' | 'BLOCK' | 'TRANSACTION' | 'ADDRESS' | 'TOKEN' | 'MODULE' | 'COIN' | 'FUNGIBLE_ASSET' | 'COLLECTION' | 'OBJECT' | 'BATCH_TRX',
    }): CancelablePromise<Array<EvmSearchHandlerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search/handler',
            query: {
                'filterBy': filterBy,
                'term': term,
            },
        });
    }

}
